export default "__VITE_ASSET__BlIiMPff__"